import request from './request.js'

const $api = {
    region: {
        /**
         * @function 获取地区集合
         * @return {Object} [{_id,name,group}]
         */
        list () {
            return request('region/list', {}, {
                success: function (res) {
                    const groupData = {};
                    res.result.forEach(data => {
                        if (!data.group) data.group = 'TOP';
                        if (!groupData[data.group]) groupData[data.group] = [];
                        const { _id, name } = data;
                        groupData[data.group].push({ _id, name })
                    })
                    res.result = groupData;
                    return res
                }
            })
        },
        /**
         * @function 获取地区页面数据
         * @parmas {string}    _id  
         * @return {Object} [{_id,name,group}]
         */
        detail (_id) {
            return request('region/detail', { _id })
        }
    },
    captcha: {
        send (params) {
            params.business = 'QUANRIZHIGATHER';
            return request('captcha/send', params, {
                name: 'tcloud',
                loading: true,
                loadingText: '发送中...'
            })
        }
    },
    form: {
        /**
        * @function 提交采集数据
        * @parmas {objct}  {name,phone,vcode,wenli,score}
        * @return {objct}  {success:_id / error: code,message}
        */
        submit (params) {
            return request('gather/data/submit', params, {
                loading: true,
                loadingText: '提交中...'
            });
        },

    }
}

export default $api